<template>
  <List
    ref="list"
    url="/api/app/courseComment"
    method="post"
    :search="params"
    @page-load="onLoad"
  >
    <template v-slot="{ list }">
      <div v-for="comment in list" :key="comment.id">
        <div class="comment-item">
          <div class="header">
            <img class="avatar" :src="comment.avatar" />
            <span class="nickname">{{ comment.nickname }}</span>
            <div style="position: relative">
              <el-rate v-model="comment.grade"></el-rate>
              <div
                style="
                  position: absolute;
                  left: 0;
                  top: 0;
                  right: 0;
                  bottom: 0;
                  z-index: 1;
                "
              ></div>
            </div>
            <div style="flex-grow: 1"></div>
            <a
              class="operate delete"
              v-if="$store.state.user_info.id == comment.uid"
              @click="onDelete(comment)"
            >
              删除
            </a>
            <a class="operate complaint" v-else @click="onComplaint(comment)">
              举报
            </a>
          </div>
          <div class="content">{{ comment.content }}</div>
          <div class="time">{{ comment.created_at | tsFormatLong }}</div>
        </div>
      </div>
      <Empty
        class="empty"
        v-if="list.length == 0"
        title="暂无课程评价信息哦！"
      />
    </template>
  </List>
</template>

<script>
import List from "@/components/List.vue";

export default {
  name: "CourseComment",
  components: { List },
  props: {
    comment: {
      type: Object,
      default: () => {
        return {};
      },
    },
    courseId: {},
  },
  computed: {
    params() {
      return { id: this.courseId };
    },
  },
  methods: {
    onComplaint(comment) {
      this.$emit("complaint", comment.id);
    },
    async onDelete(comment) {
      await this.$promiseConfirm("删除后，该内容将不再展示，是否确认？", {
        type: "warning",
      });
      await this.$http.delete("/api/app/course/comment/" + comment.id);
      this.$refs.list.refresh();
    },
    onLoad(data) {
      this.$emit("load", data);
    },
  },
};
</script>

<style scoped lang="scss">
.comment-item {
  border-bottom: 1px solid #e8e8e8;
  padding: 16px 0;

  &:last-child {
    border-bottom: none;
  }

  .header {
    display: flex;
    align-items: center;
    color: #595959;

    .avatar {
      width: 20px;
      height: 20px;
      border-radius: 100%;
      margin-right: 10px;
    }

    .nickname {
      margin-right: 20px;
      font-size: 16px;
    }

    .el-rate {
      display: inline-block;
    }

    .operate {
      font-size: 14px;
      color: rgba(89, 89, 89, 1);
      cursor: pointer;
      display: none;

      &.delete:hover {
        color: #e74d3d;
      }

      &.complaint:hover {
        color: $primary-color;
      }
    }
  }

  &:hover {
    .header {
      .operate {
        display: block;
      }
    }
  }

  .content {
    padding: 16px 0;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    word-break: break-all;
  }

  .time {
    color: rgba(0, 0, 0, 0.25);
    font-size: 14px;
  }

  /deep/ {
    .el-icon-star-on,
    .el-icon-star-off {
      color: #ea7a2f !important;
    }
  }
}
</style>
